// Library reducer types
export const GET_LIBRARY = "GET_LIBRARY"
export const GET_COMMENTS = "GET_COMMENTS"
export const ADD_COMMENT = "ADD_COMMENT"
export const GET_USER_LIBRARY = "GET_USER_LIBRARY"
export const POST_FILE = "POST_FILE"
export const FILTER_CATEGORY = "FILTER_CATEGORY"
export const FILTER_SUBJECT = "FILTER_SUBJECT"
export const DELETE_FILE = "DELETE_FILE"
export const LIKE_FILE = "LIKE_FILE"
export const GET_FILE = "GET_FILE"
export const UNLIKE_FILE = "UNLIKE_FILE"
export const SUBMIT_COMMENT = "SUBMIT_COMMENT"
export const DELETE_COMMENT = "DELETE_COMMENT"
export const SORT_BY = "SORT_BY"
export const SORT_BY_NAME = "SORT_BY_NAME"
